const welcomeTour = {
  id: 'welcome',
  title: 'Welcome to Earlymark',
  summary: 'A quick look around before you start.',
  match: '/dashboard',
  autoStart: true,
  version: 1,
  steps: [
    {
      target: 'sidebar',
      title: 'Your main menu',
      body: 'Everything lives here — Projects, Schedules, Products, Companies and Users. Click any item to jump straight to it.',
      placement: 'right',
    },
    {
      target: 'sidebar-collapse',
      title: 'Make more room',
      body: 'Toggle this button to collapse the menu down to icons. Handy when you are working in a wide schedule.',
      placement: 'right',
      // Only rendered while the sidebar is expanded.
      optional: true,
    },
    {
      target: 'navbar-search',
      title: 'Find anything fast',
      body: 'Search across your projects and schedules from any page. Partial words work too.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'help-button',
      title: 'Help whenever you need it',
      body: 'Replay any tour or browse the help centre from here. We will leave you to it.',
      tip: 'A green dot means there is a tour for the page you are on.',
      placement: 'bottom',
    },
  ],
};

export default welcomeTour;
